import React from "react";
import {FormComponent} from "../../components/FormComponent";
import {Loader} from "../../components/Loader";
import {FormSubmit} from "../../components/FormComponent/FormSubmit";
import {FormGroup} from "../../components/FormComponent/FormGroup";
import {User} from "../../components/User";
import {StatusPage} from "../StatusPage";

export class CreateCategory extends FormComponent {
    protected user: User = new User();
    protected needMount: boolean = false;

    protected getRequestUrl(): RequestInfo | URL {
        return '/product-category/create';
    }

    protected onSuccess(data: any, event: React.FormEvent | null): any {
        window.location.assign(`/product-category/edit/${data.id}`);
    }

    componentDidMount() {
        let [id] = this.getParams();

        this.request.fetch('/product-category/get', {id: id})
            .then((data: { item: { [key: string]: string } } | {
                message: string | string[]
            } | any) => {
                this.setState({
                    item: data?.item,
                    clients: data?.clients,
                    parents: data?.parents,
                    message: data?.message
                });
            }).catch(error => {
            this.onError(error);
        });
    }

    render() {
        if (this.needMount && this.state === null) {
            return <Loader/>;
        }
        if (this.needMount && this.state?.message) {
            return <StatusPage message={this.state.message}/>;
        }

        return (
            <form className="x-form" onSubmit={this.handleSubmit}>

                <input type="hidden" name="id" defaultValue={this.state?.item?.id || ''}/>

                <div className="row">

                    <div className="col-md-12 col-lg-5 col-xl-4 col-xxl-3">
                        <br/>&nbsp;
                        <h5>{this.dictionary.get['product-category']}</h5>

                        <FormGroup.Input {...{id: 'name', required: true, defaultValue: this.state?.item?.name || ''}}/>

                        <FormGroup.Select {...{
                            id: 'status',
                            required: true,
                            basic: 'please-select',
                            items: ['active', 'inactive'],
                            defaultValue: this.state?.item?.status || 'active'
                        }}/>

                        <FormGroup.Select {...{
                            id: 'parent_id',
                            required: true,
                            basic: 'please-select',
                            items: this.state.parents,
                            defaultValue: this.state?.item?.parent_id || ''
                        }}/>

                        <FormGroup.Select {...{
                            id: 'client_id',
                            required: true,
                            basic: 'please-select',
                            items: this.state.clients,
                            defaultValue: this.state?.item?.client_id || ''
                        }}/>

                        <FormSubmit/>
                    </div>
                </div>
            </form>
        );
    }
}
